import { z } from 'zod/v4';
import { PerformedBySchema } from '../../performed-by/index.js';
import { TribunalCaseStatus } from '../../tribunal/cases/types.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
const filtersSchema = z.object({});
const itemSchema = z.object({
    tribunalCaseId: z.uuid(),
    type: z.string(),
    status: z.enum(TribunalCaseStatus),
    reference: z.string().nullable(),
    country: z.string(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime().nullable(),
    createdBy: PerformedBySchema.nullable(),
});
const facetsSchema = z.object({});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchTribunalCasesTool = {
    name: ToolName.SearchTribunalCases,
    category: ToolCategory.Tribunal,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'List all tribunal (court / bailiff) cases linked to this debt case. A debt case can have multiple tribunal proceedings against it, but rarely more than a few. No filters — always returns the full list, most recent first. Call get_tribunal_case for full details on a specific one.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-tribunal-cases.js.map